import React from 'react';
import { number, string } from 'prop-types';
import classNames from 'classnames';
import { isNumber } from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import { formatAsLocalizedShortDate, formatHoursAsDays } from '../../../../../../../utils/translation/date';

import './style.scss';

const Info = ({ country, memberSince, responseTime }) => {
    const showMemberSince = isNumber(memberSince);
    const showResponseTime = isNumber(responseTime);

    if (!country && !showMemberSince && !showResponseTime) {
        return null;
    }

    const hoursAsDays = showResponseTime ? formatHoursAsDays(responseTime) : null;

    return (
        <div className={classNames('info', 'tbody-6')}>
            {country && (
                <div>
                    <I18n k="collections_perseus.collection_page.seller_card.lives_in" />
                    <b>{country}</b>
                </div>
            )}
            {showMemberSince && (
                <div>
                    <I18n k="collections_perseus.collection_page.seller_card.member_since" />
                    <b>{formatAsLocalizedShortDate(memberSince)}</b>
                </div>
            )}
            {showResponseTime && (
                <div>
                    <I18n k="collections_perseus.collection_page.seller_card.response_time" />
                    <b>
                        <I18n k={hoursAsDays.key} params={{ count: hoursAsDays.count }} />
                    </b>
                </div>
            )}
        </div>
    );
};

Info.propTypes = {
    country: string,
    memberSince: number,
    responseTime: number,
};

export default Info;
